"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mod = require("./mod");

var _config = _interopRequireDefault(require("./config"));

var mod = {
  import: _mod.import,
  export: _mod.export,
  throw: _mod.throw,
  config: _config.default,
  registerModuleResolver: _mod.registerModuleResolver
};
var _default = mod;
exports.default = _default;
//# sourceMappingURL=index.js.map